module.exports = __webpack_public_path__ + "img/banner.fb2db037.png";